<template>
  <div>
    <!--顶部标题菜单-->
    <div class = "header">
      <p class = "h_title">{{txtLang[curLang]['taskRule']}}</p>
      <a @click = "back" href = "javascript:void(0)" class = "h_btn" ></a>
    </div>

    <div class=  "body" v-html = "info">
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  components:{},
  data () {
    return {
     info:''
    }
  },
  methods: {
  	back(){
      this.$router.back(-1)
    },
    getInfo(){
      var token = localStorage.getItem('guess_token') == null ? '' : '&token=' + localStorage.getItem('guess_token');
      this.axios.get(this.getHost() + '/tasks/help?lan=' + this.langIndex + token).then(
          (response)=>{
          var re = response.data;
          if(re.code == 200){
            this.info = re.data.content;
          }
          else if(re.code == 401){
            this.gotoLogin();
          }
          else{
            alert(re.message);
          }
      }).catch((response)=>{
        console.log(response);
      });
    },
  },
  created(){
  	//控制台查看变量
    //window.vueVar = this;
    this.getInfo();
  }
}
</script>

<style scoped>
 body{background:#171531}
/*头部*/
.header{z-index:100;position:fixed;top:0;left:0;width:100%;height:120px;background:#232048}
.header .h_title{font-size:40px;color:#fff;line-height:120px;text-align:center}
.header .h_btn{width:120px;height:120px;position:absolute;top:0;left:0}
.header .h_btn:after{display:block;content:'';width:24px;height:24px;margin-top:-12px;margin-left:-12px;border-top:4px solid #fff;border-left:4px solid #fff;position:absolute;top:50%;left:50%;transform:rotate(-45deg);-webkit-transform:rotate(-45deg);-moz-transform:rotate(-45deg);-ms-transform:rotate(-45deg);-o-transform:rotate(-45deg);}

.body{padding:160px 55px;color:#bbbabf;font-size:24px}


</style>



// WEBPACK FOOTER //
// src/components/taskRule.vue